import { useState } from 'react';
import useInvitations from 'Hooks/useInvitations';
import PendingInvitationDialog from 'Components/Organisms/PendingInvitationDialog/PendingInvitationDialog';
import PendingInvitationAlert from 'Components/Organisms/PendingInvitationAlert/PendingInvitationAlert';

export default function AppLayoutNoticesInvitations() {
    const [showModal, setShowModal] = useState(false);
    const { invitations } = useInvitations();

    if (invitations.length === 0) {
        return null;
    }

    const invitation = invitations[0];

    return (
        <>
            <PendingInvitationDialog invitation={invitation} open={showModal} onClose={() => setShowModal(false)} />
            <PendingInvitationAlert invitation={invitation} onCheck={() => setShowModal(true)} />
        </>
    );
}
